import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  setAllTrackings,
  setMyTrackings,
} from "../../../../../redux/Tracking/actionCreator";
import { Modal, Form, Row, Col, Button } from "react-bootstrap";
import BarLoader from "react-spinners/ClipLoader";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { api } from "../../../../../Services/api";
import { useFetch } from "../../../../../Hooks/useFetch";
import { key } from "../../../../../data/queryKeys";
import moment from "moment";

export const Clone = ({
  showClone,
  setTaskview,
  setShowClone,
  viewTaskData,
  item,
  allTrackingsList,
  setShowAlertBox,
  setAlertMessage,
  clonetaskData,
  setCloneTask,
  backTo,
  taskfile,
  taskfileList,
}) => {
  /********************* Make clone task as mandatory TRWH-1106 *****************/
  const clientId = useSelector((state) => state.Auth.user.trackingclientid);
  const [loadingFile, setLoadingFile] = useState(false);
  const [bufferFile, setBufferFile] = useState([]);
  const [imgUpldLoading, setImgUpldLoading] = useState(false);
  const [holidays, setHolidays] = useState([]);

  const dispatch = useDispatch();
  const trackingClientId = useSelector(
    (state) => state.Auth.user.trackingclientid,
  );
  const myTrackingList = useSelector((state) => state.Tracking.myTrackings);
  const authToken = useSelector((state) => state.Auth.authToken);
  const user = useSelector((state) => state.Auth.user);
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const [loading, setLoading] = useState(false);

  const { data: allTasksTypesRes } = useFetch(
    key.get_all_tasktypes,
    "/trackingtasktype",
    () => {},
    () => {},
    false,
    true,
  );
  let allTaskTypes = allTasksTypesRes?.data ?? [];

  const { data: allProjectsRes } = useFetch(
    key.get_all_projects,
    `/trackingprojects/${trackingClientId}`,
    () => {},
    () => {},
    false,
    false,
  );
  let allProjects = allProjectsRes?.data?.Items ?? [];

  const { data: allMembersRes } = useFetch(
    key.get_all_members,
    `/trackingusers/memberlist/${trackingClientId}`,
    () => {},
    () => {},
    false,
    false,
  );
  let allMembers = allMembersRes?.data ?? [];

  let results = [];

  let team_mates = allProjects.find(
    (e) => e.trackingprojectid === viewTaskData.projectid,
  );

  if (team_mates) team_mates = team_mates.teammates;
  if (team_mates) {
    team_mates.forEach((element) => {
      results.push({ label: element.label, id: element.id });
    });
    allMembers = [...results, { label: "None", id: "notAssigned" }];
  }

  if (allProjects.length > 0) {
    let results = [];
    allProjects.forEach((element) => {
      results.push({ label: element.label, id: element.trackingprojectid });
    });
    allProjects = results;
  }

  if (allTaskTypes.length > 0) {
    let results = [];
    allTaskTypes.forEach((item) =>
      results.push({ label: item?.label, id: item?.id }),
    );
  }

  function addEtaFromNow(eta) {
    if (!eta) return "";

    // Extract number from strings like "8 hrs"
    const hours = parseInt(eta, 10);
    if (isNaN(hours)) {
      console.error("Invalid eta format:", eta);
      return "";
    }

    // Start from current time
    const now = new Date();
    now.setHours(now.getHours() + hours);

    // Return formatted date
    return now.toISOString();
  }

  useEffect(() => {
    api
      .get(`/tracking/holidays/${clientId}`, {
        headers: {
          authorizationtoken: ` ${authToken}`,
        },
      })
      .then((res) => {
        console.log(res, "resres");
        setHolidays(
          res?.data?.data?.map((item) => {
            return moment(item?.holidaydate, "YYYY-MM-DD").format("DD-MM-YYYY");
          }),
        );
      })
      .catch(console.error);
  }, []);

  function addWorkHoursConsideringShift(
    startTime,
    workHours,
    shiftStartStr,
    shiftEndStr,
  ) {
    const safeShiftStart =
      typeof shiftStartStr === "string" && shiftStartStr?.trim() !== ""
        ? shiftStartStr
        : "09:00:00";
    const safeShiftEnd =
      typeof shiftEndStr === "string" && shiftEndStr?.trim() !== ""
        ? shiftEndStr
        : "17:00:00";

    const [sH, sM, sS] = safeShiftStart.replace("Z", "").split(":").map(Number);
    const [eH, eM, eS] = safeShiftEnd.replace("Z", "").split(":").map(Number);

    if ([sH, eH].some(isNaN)) {
      console.warn("⚠️ Invalid shift hours, using default 9AM–5PM");
      return new Date(startTime.getTime() + workHours * 60 * 60 * 1000);
    }

    const result = new Date(startTime);
    let remainingHours = workHours;

    while (remainingHours > 0) {
      const shiftStart = new Date(result);
      shiftStart?.setHours(sH, sM, sS, 0);
      const shiftEnd = new Date(result);
      shiftEnd?.setHours(eH, eM, eS, 0);
      if (shiftEnd <= shiftStart) shiftEnd.setDate(shiftEnd?.getDate() + 1);

      const day = shiftStart.getDay();
      // console.log("holidays-->", holidays);
      if (
        day === 6 ||
        day === 0 ||
        holidays?.includes(moment(shiftStart).format("DD-MM-YYYY"))
      ) {
        const daysToAdd = day === 6 ? 2 : 1;
        shiftStart.setDate(shiftStart?.getDate() + daysToAdd);
        shiftEnd.setDate(shiftEnd?.getDate() + daysToAdd);
        result.setTime(shiftStart?.getTime());
        continue;
      }

      if (result < shiftStart) result?.setTime(shiftStart?.getTime());
      if (result >= shiftEnd) {
        shiftStart.setDate(shiftStart?.getDate() + 1);
        result.setTime(shiftStart?.getTime());
        continue;
      }

      const availableHoursToday = (shiftEnd - result) / (1000 * 60 * 60);
      const hoursToAdd = Math.min(availableHoursToday, remainingHours);
      result?.setTime(result.getTime() + hoursToAdd * 60 * 60 * 1000);
      remainingHours -= hoursToAdd;

      if (remainingHours > 0) {
        shiftStart?.setDate(shiftStart?.getDate() + 1);
        result?.setTime(shiftStart?.getTime());
      }
    }

    console.log("Final ETA result:", result);
    return result;
  }

  function computeEtaAndDeadlineFromPriority(
    priorityKey,
    project,
    matchedProject,
  ) {
    // const priorityHoursMap = {
    //   blocker1: 4,
    //   blocker2: 8,
    //   "blocker level 1": 4,
    //   "blocker level 2": 8,
    //   major: 16,
    //   medium: 40,
    //   low: 80,
    // };

    const priorityHoursMap = {
      blocker1: 4,
      blocker2: 8,
      // blocker1: 4,
      // blocker2: 8,
      "blocker level 1": 4,
      "blocker level 2": 8,
      major: 16,
      medium: 40,
      low: 80,
    };
    // const totalHours = priorityHoursMap[priorityKey] || 0;
    // console.log(totalHours, "totalHours");
    // const workStartHour = matchedProject?.starttime;
    // const workEndHour = matchedProject?.endtime;
    // const now = new Date();
    const totalHours = priorityHoursMap[priorityKey?.toLowerCase()] || 0;
    const workStartHour = `${matchedProject?.starttime}:00`;
    const workEndHour = `${matchedProject?.endtime}:00`;
    const now = new Date();

    // ✅ Step 1: Validate start & end time
    const hasValidShift =
      typeof workStartHour === "string" &&
      workStartHour.trim() !== "" &&
      typeof workEndHour === "string" &&
      workEndHour.trim() !== "";

    let eta;

    if (hasValidShift) {
      // ✅ Use shift-based calculation
      eta = addWorkHoursConsideringShift(
        now,
        totalHours,
        workStartHour,
        workEndHour,
      );
    } else {
      // ⚠️ Fallback: Just add straight hours to current time
      console.warn(
        "⚠️ Missing or empty start/end time, using default ETA calculation",
      );
      eta = new Date(now?.getTime() + totalHours * 60 * 60 * 1000);
    }

    // ✅ Validate that eta is a valid Date
    const safeEta = eta instanceof Date && !isNaN(eta) ? eta : new Date();

    return {
      startTime: now?.toISOString(),
      estimatedEndTime: safeEta?.toISOString(),
      totalHours: totalHours,
    };
  }

  const onSubmitHandle = async () => {
    if (clonetaskData.assignedto !== "") {
      setLoading(true);
      // Find the project to get istaskapproval
      let project = allProjects.find((e) => e.id === item.trackingprojectsid);
      let istaskapproval = project?.istaskapproval;

      const deadline = computeEtaAndDeadlineFromPriority(
        item.priority,
        null,
        project,
      );
      let Obj = {
        title: clonetaskData.title,
        trackingprojectsid: item.trackingprojectsid,
        type: item.type,
        priority: item.priority,
        fileurls: [],
        filesize: [],
        description: item.description,
        reportedby: user.trackinguserid,
        assignedto: clonetaskData.assignedto,
        timezone: timezone,
        authorizationToken: authToken,
        eta: deadline.totalHours,
        deadline: deadline?.estimatedEndTime,
        istaskapproval: istaskapproval,
      };
      api
        .post("/tracking/" + trackingClientId, Obj, {
          headers: {
            authorizationtoken: ` ${authToken}`,
          },
        })
        .then(async function (response) {
          if ((response.status = 200)) {
            let item = {
              trackingid: response.data.data.trackingid,
              trackingclientid: response.data.data.trackingclientid,
              trackingprojectsid: response.data.data.trackingprojectsid,
              comments: response.data.data.comments,
              history: response.data.data.history,
              description: response.data.data.description,
              priority: response.data.data.priority,
              fileurls: response.data.data.fileurls,
              filesize: response.data.data.filesize,
              title: response.data.data.title,
              type: response.data.data.type,
              trackingprojectstatusid:
                response.data.data.trackingprojectstatusid,
              assignedto: clonetaskData.assignedto,
              reportedby: user.trackinguserid,
              reporteddate: response.data.data.reporteddate,
              deadline: response.data.data.deadline,
              eta: response.data.data.eta,
            };
            if (response.data.data.trackingprojectstatusid != 1) {
              allTrackingsList.push(item);
              if (response.data.data.assignedto == user.trackinguserid)
                myTrackingList.push(item);
            }
            // Call taskfilter API after cloning
            try {
              // Use the same payload structure as TrackingListHeader
              const userAccessibleProjects = user?.projectList || [];
              const payload = {
                trackingprojectsid: [],
                assignedto: [],
                tasktype: [],
                priority: [],
                reportedby: [],
                status: [],
                fromdate: "",
                todate: "",
                userAccessibleProjects: userAccessibleProjects,
                trackingclientId: trackingClientId,
              };
              const filterRes = await api.post(
                "/tracking/taskfilter",
                payload,
                {
                  headers: {
                    authorizationtoken: ` ${authToken}`,
                  },
                },
              );
              if (
                filterRes.status === 200 &&
                filterRes.data &&
                Array.isArray(filterRes.data.data)
              ) {
                dispatch(setAllTrackings(filterRes.data.data));
              }
            } catch (err) {
              console.error("Error fetching filtered tasks:", err);
            }
            dispatch(setAllTrackings([...allTrackingsList]));
            dispatch(setMyTrackings([...myTrackingList]));
            setLoading(false);
            bufferFile.length === 0 && setShowClone(false);
            bufferFile.length === 0 && setTaskview(backTo);
            setShowAlertBox(true);
            setAlertMessage(
              "(" +
                trackingClientId +
                "-" +
                response.data.data.trackingid +
                ")" +
                " New tracking item has been created successfully",
            );
          }
        })
        .catch((e) => {
          setLoading(false);
        });
    }
  };

  // const uploadImage = async (trackingid) => {
  //   bufferFile.length >= 0 && setImgUpldLoading(true)
  //   for (let i = 0; i < taskfile.length; i++) {
  //     axios({
  //       url: 'https://trackingapitestupload.hashching.org/upload/' + trackingClientId + '/S3' + trackingClientId + trackingid + '/' + taskfileList[i],
  //       method: "POST",
  //       fileurl: bufferFile[i],
  //       headers: {
  //         'content-type': 'image/png'
  //       },
  //       data: bufferFile[i]
  //     }).then((response) => {
  //       if (i === bufferFile.length - 1) {
  //         setImgUpldLoading(false)
  //         setShowClone(false);
  //         setTaskview(backTo);
  //       }
  //     }).catch((e) => {
  //       console.log("img Upload Error", e)
  //       setImgUpldLoading(false)
  //     })
  //   }
  // }

  const handleSplChar = (e) => {
    if (
      e.key === "#" ||
      e.key === "$" ||
      e.key === "^" ||
      e.key === "@" ||
      e.key === "*" ||
      e.key === "(" ||
      e.key === "!" ||
      e.key === ")" ||
      e.key === "%" ||
      e.key === "="
    ) {
      e.preventDefault();
    }
  };
  return (
    <>
      {showClone && (
        <div className="clone-task-form">
          <h5 className="clone">
            Clone task: {trackingClientId}-{item.trackingid}
          </h5>
          {/* <CloseRoundedIcon
            className='close-icon float_close_icon'
            onClick={() => setShowClone(false)}
            sx={{ fontSize: 10 }}
          /> */}

          <Form
            autoComplete="off"
            onSubmit={(e) => {
              e.preventDefault();
              onSubmitHandle();
            }}
          >
            <Row>
              <Col>
                <Form.Group controlId="title">
                  <Form.Label> Title: </Form.Label>
                  <Form.Control
                    type="text"
                    value={clonetaskData.title}
                    placeholder="Enter Title"
                    name="title"
                    maxLength="80"
                    onKeyDown={handleSplChar}
                    onChange={(e) =>
                      setCloneTask((prevState) => ({
                        ...prevState,
                        title: e.target.value,
                      }))
                    }
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row className="mt-3">
              <Col>
                <Form.Group controlId="assigned_to">
                  <Form.Label> Assigned to:: </Form.Label>
                  <Form.Control
                    as="select"
                    name="assigned_to"
                    value={clonetaskData.assignedto}
                    required
                    onChange={(e) =>
                      setCloneTask((prevState) => ({
                        ...prevState,
                        assignedto: e.target.value,
                      }))
                    }
                  >
                    <option value="">Select...</option>
                    {allMembers.map((member) => (
                      <option value={member.id} key={member.id}>
                        {member.label}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
              </Col>
            </Row>

            <Row className="mb-2 mt-3">
              <Col className="text-center" sm={12}>
                <Button
                  style={{
                    width: "100px",
                    padding: "4px 4px 4px 13px",
                    fontSize: "17px",
                  }}
                  type="button"
                  size="sm"
                  onClick={() => setShowClone(false)}
                  className="btn mx-2 my-2"
                  variant="secondary"
                >
                  Cancel
                </Button>

                <Button
                  type="submit"
                  size="sm"
                  className="mx-2 my-2 loginSubmitBtn btn btn-orange"
                  disabled={!(clonetaskData.title || loadingFile)}
                  variant="orange"
                  style={{
                    width: "100px",
                    padding: "4px 4px 4px 13px",
                    fontSize: "17px",
                    background: loading ? "#FFFFFF" : "#4EB6EE",
                    color: loading ? "#808080" : "#FFFFFF",
                    border: loading ? "2px solid #FFFFFF" : "2px solid #4EB6EE",
                  }}
                >
                  {loading || imgUpldLoading ? (
                    <BarLoader
                      color="#808080"
                      className="bar-loader"
                      size={14}
                      role="status"
                      aria-hidden="true"
                    />
                  ) : null}
                  Submit
                </Button>
              </Col>
            </Row>
          </Form>
        </div>
      )}
    </>
  );
};
